import request from '@/router/axios';
import store from "@/store";

export const getButtons = () => request('/api/blade-system/menu/buttons');

export const getMenu = () => request('/api/system/menu/nav');

/**
 * 获取用户基本信息
 * @param usernameOrMobile 用户名/手机号
 * @returns {Object} 返回对象
 *          {String} username 用户名
 *          {String} mobile 脱敏后的手机号
 *          {String} email 脱敏后的邮箱
 */
 export const getUserInfoByUsernameOrMobile = (usernameOrMobile) => request(`/api/system/user/info/base/${usernameOrMobile}`)

/**
 * 发送手机验证码
 * @param phone 手机号
 */
 export const sendSmsByPhone = (phone) => {
    return request(`/api/system/sms/send/${phone}`, undefined, 'post')
}

export const register = (data = {}) => {
    return request('/api/system/user/register', {data}, 'post')
}

/**
 * 通过手机号注册用户
 * @param {object} data 用户信息
 *        {string} data.mobile *手机号，11位数字组成的字符串
 *        {string} data.phoneCode *手机验证码，6位数字组成的字符串
 *        {string} data.password *登录密码
 *        {array} data.roleIdList *所属角色ID列表。至少要有一个角色
 *        {number} data.roleIdList[0] *所属角色
 *        {number} data.deptId 所属学校/组织机构ID。与deptName二选一，必填
 *        {string} data.deptName 所属学校/组织机构名称。与deptId二选一，必填
 *        {string} data.joinCode 注册邀请码。角色为非审批角色时，必填
 *        {number} data.inviteUserCountMax 可邀请的最大用户数。针对审批角色
 */
export const registerByPhone = (data = {}) => {
    return request('/api/system/user/registerByPhone', { data }, 'post')
}

export const resetPasswordByPhone = (data = {}) => {
    return request('/api/system/user/phone/password/reset', { data }, 'post')
}

export const getUserInfo = () => request('/api/system/user/loginUser', {
    meta: {
        isToken: true
    }
});

/**
 * 修改密码
 * @param {Object} params
 * @param {String} params.password 原密码
 * @param {String} params.newPassword 新密码
 */
export const updatePassword = (params) => {
    return request('/api/system/user/password', {
        params
    }, 'put');
};

/**
 * 修改用户信息
 * @param {Object} data
 * @param {Number} data.id *id
 * @param {String} data.avatar 头像
 * @param {String} data.mobile 手机号
 * @param {String} data.phoneCode 手机验证码。更换/绑定手机号时必填
 * @param {String} data.email 邮箱
 * @param {String} data.emailActivation 邮箱是否已验证。更换/绑定邮箱时必填
 * @param {String} data.nickname 昵称
 * @param {String} data.username 用户名
 * @param {String} data.sex 性别
 */
export const updateUserBase = data => {
    const { id, email } = data
    if (id === undefined || id === null || id < 1) {
        return Promise.reject(new Error("参数错误"))
    }
    // 不更新无意义字段
    if (email === undefined || email === null || email === '') {
        delete data.email
        delete data.emailActivation
    }
    // 不更新用户名
    delete data.username
    return request('/api/system/user/update/base', { data }, 'put')
}

export const getTeacherTopList = (num = 10, params = {}) => {
    return request(`/api/system/user/getTeacherTopList/${num}`, {params})
}

export const getTopList = (software = '实验工坊', num = 10, params = {}) => {
    return request(`/api/system/user/getTopList/${software}/${num}`, {params})
}

export async function getCurUserInfo() {
    let req = {}
    await getUserInfo().then(userInfo => {
        req = userInfo
    }).catch(() => {
    })
    return req
}

/**
 * 查重操作
 * @param {Object} params 参数
 */
export const duplicateCheck = (params = {}) => {
    return request('/api/system/user/duplicateCheck', {params})
}


// /user/email/verify    激活邮箱
export const emailVerify = (params = {}) => {
    return request('/api/system/user/email/verify', {params})
}


// /user/email/change    更换邮箱
export const emailChange = (params = {}) => {
    return request('/api/system/user/email/change', {params})
}

/**
 * 更换密码
 * @param params
 */
export const passwordReset = (params = {}) => {
    return request('/api/system/user/email/password/reset', {params})
}

/**
 * 绑定微信
 * @param code 微信授权返回的code
 */
export function bindWechat(code) {
    if (!code) {
        return Promise.reject(new Error("参数错误"))
    }
    return new Promise((resolve, reject) => {
        request('/api/system/user/bind/wechat', {
            data: {
                code
            }
        }, "post")
            .then(() => {
                // 修改当前登录用户的微信绑定状态
                store.dispatch("GetUserInfo")
                    .then(() => resolve())
                    .catch(e => reject(e))
            })
            .catch(e => {
                reject(e)
            })
    })
}

/**
 * 解绑微信
 */
export function unbindWechat() {
    return new Promise((resolve, reject) => {
        request('/api/system/user/unbind/wechat', {}, "post")
            .then(() => {
                // 修改当前登录用户的微信绑定状态
                store.dispatch("GetUserInfo")
                    .then(() => resolve())
                    .catch(e => reject(e))
            })
            .catch(e => {
                reject(e)
            })
    })
}

/**
 * 解绑云课时间
 */
export function unbindWincourse() {
    return new Promise((resolve, reject) => {
        request('/api/system/user/unbind/wincourse', {}, "put")
            .then(() => {
                // 修改当前登录用户的微信绑定状态
                store.dispatch("GetUserInfo")
                    .then(() => resolve())
                    .catch(e => reject(e))
            })
            .catch(e => {
                reject(e)
            })
    })
}
